import React from 'react';
import { Container, FONT_SIZE, VARIANTS } from './style';

/**
 * @typedef {Object} TextProps
 * @property {'title' | 'sub_title' | 'text' | 'info'} variant
 * @property {'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl'} size
 * @property {React.CSSProperties} style
 */

/**
 * @param {TextProps } props
 * @returns {JSX.Element}
 */
export function Text({
  children,
  size,
  color,
  variant = 'text',
  style = {},
}) {
  return (
    <Container
      style={{
        color,
        ...(VARIANTS[variant] || {}),
        ...(FONT_SIZE[size] || {}),
        ...style,
      }}
    >
      {children}
    </Container>
  );
}
